import React, { useState } from "react";
import "./AdminUserVisualisation.css";
import PersonalityUserCharts from "../../UserCharts/PersonalityUserCharts";

const AdminUserPersonalityVisualisation = ({ allUserData }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserScores, setSelectedUserScores] = useState([]);

  const handleChange = async (event) => {
    const username = event.target.value;
    setSelectedOption(username);
    setSelectedUserScores([]);

    const user = allUserData.find((u) => u.username === username);
    setSelectedUser(user);

    if (!user) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/personality-history?username=${username}`,
        { credentials: "include" }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const userFromApi = Array.isArray(data)
        ? data.find((u) => u.username === username)
        : null;

      setSelectedUserScores(userFromApi?.scores || []);
    } catch (err) {
      console.error("Error fetching user scores:", err);
      setSelectedUserScores([]);
    }
  };

  return (
    <div className="admin-visualisation">
      <h2>Per User – Personality Visualisation</h2>

      <div style={{ marginBottom: "16px" }}>
        <label>
          Select a user:
          <select
            value={selectedOption}
            onChange={handleChange}
            style={{ marginLeft: "8px" }}
          >
            <option value="" disabled>
              Select a user
            </option>
            {allUserData.map((user) => (
              <option key={user.email} value={user.username}>
                {user.username}
              </option>
            ))}
          </select>
        </label>
      </div>

      {selectedUser ? (
        <PersonalityUserCharts user={{ ...selectedUser, scores: selectedUserScores }} />
      ) : (
        <div>Please select a user to view their charts.</div>
      )}
    </div>
  );
};

export default AdminUserPersonalityVisualisation;
